import React from "react";
import i18n from "i18next";
import AudioCueComponent from "./AudioCueComponent";
import audio_placeholder from "./../../dist/images/useanimage.svg";
import { audioCueManual } from "../../common/audio_cue_manual.es6";

/* eslint-disable react/prop-types */
export function AudioCue(base) {
  return {
    getConfig: function () {
      return {
        name: "AudioCue",
        displayName: i18n.t("AudioCue.PluginName"),
        category: "multimedia",
        flavor: "react",
        needsTextEdition: false,
        initialWidth: "60px",
        initialHeight: "60px",
        initialWidthSlide: "6.86%",
        initialHeightSlide: "12.58%",
        icon: "queue_music",
        createFromLibrary: ["audio/*", "url"],
        searchIcon: true,
      };
    },
    getToolbar: function (state, box) {
      return {
        main: {
          __name: "Main",
          accordions: {
            basic: {
              __name: i18n.t("AudioCue.config"),
              icon: "build",
              buttons: {
                //TODO: Deprecated url
                /* url: {
                  __name: i18n.t("AudioCue.URL"),
                  type: "external_provider_without_input",
                  value: state.url,
                  accept: "audio/*",
                }, */
                //TODO: Deprecated sound list
                sound_list: {
                  __name: i18n.t("soundList"),
                  type: "sound_list",
                  value: state.soundList,
                  hide: !(state.soundList && state.soundList.length),
                },

                // Shows the cue's actual start; a change is saved as `manual`.
                manual: {
                  __name: i18n.t("AudioCue.AutoPlay"),
                  type: "checkbox",
                  checked: !audioCueManual(state, box),
                  inverted: true,
                },
                volume: {
                  __name: i18n.t("Sound.VolumeLevel") + ` (%${state.volume})`,
                  type: "range",
                  min: 0,
                  max: 100,
                  state: state.volume,
                  value: state.volume,
                },
                colorCue: {
                  __name: i18n.t("AudioCue.Color"),
                  type: "color",
                  value: state.colorCue || "#a963f5",
                  hide: !!state.playerView,
                },
                useImage: {
                  __name: i18n.t("AudioCue.UseImage"),
                  type: "checkbox",
                  checked: state.useImage,
                },
                icon: {
                  __name: i18n.t("AudioCue.Image"),
                  type: "external_provider",
                  hide: !state.useImage,
                  value: state.icon,
                  accept: "image/*",
                },
                playerView: {
                  __name: i18n.t("AudioCue.PlayerView"),
                  type: "checkbox",
                  checked: state.playerView,
                },
                hideAnimation: {
                  __name: i18n.t("AudioCue.HideAnimation"),
                  type: "checkbox",
                  checked: state.hideAnimation,
                  hide: !!state.playerView,
                },
              },
            },
          },
        },
      };
    },
    onStateUpdated: function (name, value, toolbar) {
      if (name !== "playerView") return null;
      const structure = toolbar.structure || {};
      const current = {
        width: structure.width,
        height: structure.height,
        widthUnit: structure.widthUnit,
        heightUnit: structure.heightUnit,
      };
      if (value) {
        return {
          structure: { width: 30, height: 6.5, widthUnit: "%", heightUnit: "%" },
          state: { cueSize: current },
        };
      }
      const prev = toolbar.state && toolbar.state.cueSize;
      return {
        structure: prev || { width: 6.86, height: 12.58, widthUnit: "%", heightUnit: "%" },
      };
    },
    getInitialState: function () {
      return {
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/sound/Beethoven-Symphony9.mp3",
        autoplay: false,
        manual: false,
        colorCue: "#a963f5",
        useImage: false,
        volume: 100,
        icon: "https://host.elearningsolutions.net/IdealStudioEditor/images/useanimage.svg",
        soundList: [],
      };
    },
    getRenderTemplate: function (state, props) {
      return <AudioCueComponent props={props} state={state} />;
    },
  };
}
/* eslint-enable react/prop-types */
